import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { TabNames } from '@models/enums/TabNames';

import { ContactView } from '@api-proxies';
import { ContactService } from '@http/clients/contact.service';
import { EditorComponentBase } from 'ngx-lib';
import { InternalNavigatorComponent } from '../../internal-navigator/internal-navigator.component';
import { TypeAheadContactsComponent } from '../../type-ahead-contacts/type-ahead-contacts.component';

@Component({
    selector: 'app-contacts-editor',
    templateUrl: './contacts-editor.component.html',
    styleUrls: ['./contacts-editor.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [InternalNavigatorComponent, TypeAheadContactsComponent]
})
export class ContactsEditorComponent extends EditorComponentBase<number | undefined> implements OnInit {
    selectedItem?: ContactView;

    displaySelectedContact: boolean;

    showInternalNavigator?: boolean;

    routeToSingle?: string;

    constructor(private readonly contactService: ContactService) {
        super();
        this.displaySelectedContact = true;
    }

    async ngOnInit(): Promise<void> {
        this.showInternalNavigator = this.additionalInfo?.allowToNavigate;
        if (this.bindingProperty) {
            this.selectedItem = await this.contactService.getById(this.bindingProperty);
            this.setRouteToNavigate(this.selectedItem);
        }
    }

    onSelectedContact(contact: ContactView) {
        this.selectedItem = contact;
        this.bindingProperty = this.selectedItem?.id;
    }

    setRouteToNavigate(contact: ContactView) {
        this.routeToSingle = `contacts-single/${contact.id}/${TabNames[TabNames.Overview]}`;
    }
}
